<template>
  <div>
    <Navbar v-if="$route.name == 'gdqshortsettings'"/>
    <!-- <Breadcrumb v-if="$route.name == 'gdqshortsettings'" /> -->
    <div class="col-12 px-0 mx-0 mt-2">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 0}"
            @click="activeTab = 0"
            type="button"
          >
            <fa-icon class="me-2" name="money-bill" />
            Pricing
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 1}"
            @click="activeTab = 1"
            type="button"
          >
            <fa-icon class="me-2" name="envelope" />
            Invitations
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 2}"
            @click="activeTab = 2"
            type="button"
          >
            <fa-icon class="me-2" name="tasks" />
            GDQ Short Questions
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 3}"
            @click="activeTab = 3"
            type="button"
          >
            <fa-icon class="me-2" name="print" />
            Report Texts
          </button>
        </li>
      </ul>
      <div class="tab-content mt-3">
        <div v-if="activeTab === 0" class="tab-pane show active">
          <div class="border-0 mx-0 ps-3 col-12">
            <div class="row">
              <div class="col-12">
                <div class="mb-3 d-flex align-items-center">
                  <label class="col-form-label" style="width: 33%; flex-shrink: 0;">VAT rate (%)</label>
                  <div style="width: 58%;">
                    <input 
                      id="gdqshort_vat" 
                      class="form-control"
                      v-model="gdqshort_vat"
                      @change="savepref('gdqshort_vat',gdqshort_vat)" 
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3 d-flex align-items-center">
                  <label class="col-form-label" style="width: 33%; flex-shrink: 0;">GDQ Short Report price per survey</label>
                  <div style="width: 58%;">
                    <input 
                      id="gdqshortreport_price" 
                      class="form-control"
                      v-model="gdqshortreport_price"
                      @change="savepref('gdqshortreport_price',gdqshortreport_price)" 
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="activeTab === 1" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <DefaultGDQShortMailTexts />
          </div>
        </div>
        <div v-if="activeTab === 2" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <Maintenance tablename="g_gdqshortquestions" />
          </div>
        </div>
        <div v-if="activeTab === 3" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <Maintenance tablename="g_shortreporttexts" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import Maintenance from './Maintenance';
import DefaultGDQShortMailTexts from './DefaultGDQShortMailTexts';
import Navbar from './Navbar.vue';
// import Breadcrumb from './Breadcrumb.vue';
export default {
  name: 'GDQShortSettings',
  mounted() {
    this.prefs_get();
  },
  components: {
    Maintenance,
    DefaultGDQShortMailTexts,
    Navbar,
    // Breadcrumb,
  },
  data: function() {
    return {
      activeTab: 0,
      gdqshortreport_price: 0,
      gdqshort_vat: 0,
    }
  },
  methods: {
    savepref(key,value) {
      if (key.indexOf('_date') != -1) {
        value = this.format_date(value);
      }
      this.$store.dispatch('syspref_save', { key: key,value: value });
    },
    prefs_get() {
      this.$store.dispatch('syspref_fetch', { key: 'gdqshortreport_price' })
      .then((resp) => {
        this.gdqshortreport_price = resp.data.value;
        this.$store.dispatch('syspref_fetch', { key: 'gdqshort_vat' })
        .then((resp) => {
          this.gdqshort_vat = resp.data.value;
        });
      });
    },
  },
}
</script>
<style>
</style>
